var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select-option-group',{attrs:{"disabled-field":_vm.disabledField,"label":_vm.label,"options":_vm.options,"text-field":_vm.textField,"value-field":_vm.valueField}},[_vm._t("first",null,{"slot":"first"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }